import produce from "immer";
/**
 * Note that this state is *not* persisted in our local storage. This state is only persisted for as long as the app
 * persists. EG: If the user forces a refresh of their page, that is a new state.
 */

// Actions
export const LOADED = "temporary/LOADED";

const initialState = {
  // The user is loading the app from a "fresh" state
  initialLoad: true,
};

// Reducer.
export default function reducer(state = initialState, action = {}) {
  return produce(state, (draft) => {
    switch (action.type) {
      case LOADED: {
        draft.initialLoad = false;

        break;
      }
    }
  });
}

// Action Creators
export function setLoaded() {
  return { type: LOADED };
}

// selector
export function selectSession(state) {
  return state.temporary;
}
